import React from 'react';
import { Card, Row, Col, Button, Typography, Space } from 'antd';
import {
  VideoCameraAddOutlined,
  SafetyCertificateOutlined,
  RocketOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const { Title, Paragraph, Text } = Typography;

function UploadPromotionBanner() {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return null; // Only show for authenticated users
  }

  return (
    <Card
      style={{
        background: 'linear-gradient(135deg, #14B8A6 0%, #0D9488 100%)',
        marginBottom: '24px',
        border: 'none',
        boxShadow: '0 8px 24px rgba(20, 184, 166, 0.25)',
      }}
    >
      <Row gutter={[24, 24]} align="middle">
        <Col xs={24} md={14}>
          <Space direction="vertical" size="small">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <RocketOutlined style={{ fontSize: '24px', color: '#fff' }} />
              <Title level={3} style={{ margin: 0, color: '#fff' }}>
                Tingkatkan Poin Anda!
              </Title>
            </div>
            <Paragraph style={{ color: 'rgba(255, 255, 255, 0.9)', margin: '8px 0', fontSize: '15px' }}>
              Upload konten video AI atau sertifikasi dari Google untuk mendapatkan poin
              dan naik ranking di leaderboard
            </Paragraph>
            <div style={{ display: 'flex', gap: '12px', marginTop: '12px', flexWrap: 'wrap' }}>
              <div style={{
                background: 'rgba(255, 255, 255, 0.2)',
                padding: '8px 16px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <TrophyOutlined style={{ color: '#ffd700', fontSize: '18px' }} />
                <Text style={{ color: '#fff', fontWeight: 500 }}>
                  Video Disetujui = +1 Poin
                </Text>
              </div>
              <div style={{
                background: 'rgba(255, 255, 255, 0.2)',
                padding: '8px 16px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <SafetyCertificateOutlined style={{ color: '#fff', fontSize: '18px' }} />
                <Text style={{ color: '#fff', fontWeight: 500 }}>
                  Sertifikasi Terverifikasi
                </Text>
              </div>
            </div>
          </Space>
        </Col>
        <Col xs={24} md={10}>
          <Row gutter={[12, 12]}>
            <Col xs={24} sm={12}>
              <Button
                type="primary"
                size="large"
                block
                icon={<VideoCameraAddOutlined />}
                onClick={() => navigate('/my-videos')}
                style={{
                  height: '56px',
                  fontSize: '16px',
                  fontWeight: 600,
                  background: 'linear-gradient(135deg, #FF8E53 0%, #FF6B6B 100%)',
                  color: '#fff',
                  border: 'none',
                  boxShadow: '0 4px 12px rgba(255, 107, 107, 0.3)',
                }}
              >
                Upload Video
              </Button>
            </Col>
            <Col xs={24} sm={12}>
              <Button
                type="default"
                size="large"
                block
                icon={<SafetyCertificateOutlined />}
                onClick={() => navigate('/certifications/upload')}
                style={{
                  height: '56px',
                  fontSize: '16px',
                  fontWeight: 600,
                  background: 'rgba(255, 255, 255, 0.95)',
                  color: '#0D9488',
                  border: '2px solid rgba(255, 255, 255, 0.3)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
                }}
              >
                Upload Sertifikasi
              </Button>
            </Col>
          </Row>
          <Paragraph style={{
            color: 'rgba(255, 255, 255, 0.8)',
            fontSize: '12px',
            marginTop: '12px',
            marginBottom: 0,
            textAlign: 'center'
          }}>
            ✨ Kontribusi Anda membantu komunitas AI di ITERA!
          </Paragraph>
        </Col>
      </Row>
    </Card>
  );
}

export default UploadPromotionBanner;
